import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ModalService } from '../../../services/modal.service';

@Component({
  selector: 'app-external-link-disclaimer',
  templateUrl: './external-link-disclaimer.component.html',
  styleUrls: ['./external-link-disclaimer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ExternalLinkDisclaimerComponent {
  public targetUrl: string;

  constructor(private modalService: ModalService) {}

  public cancel(): void {
    this.modalService.close();
  }

  public continue(): void {
    window.open(this.targetUrl, '_blank', 'noopener,noreferrer');
    this.modalService.close();
  }
}
